import React from 'react';
import { FormControl, Box, OutlinedInput } from '@mui/material';

interface MerchantNameFieldProps {
  field?: any;
  form?: any;
  storeId: any;
}

const MerchantNameField: React.FC<MerchantNameFieldProps> = ({ storeId }) => (
  <FormControl fullWidth sx={{ width: '401px' }}>
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <OutlinedInput
        value={storeId?.merchantName || ''}
        readOnly
        sx={{
          width: '401px',
          pointerEvents: 'none',
          '& .MuiOutlinedInput-input': {
            color: 'rgba(0, 0, 0, 0.87)',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
          },
        }}
      />
    </Box>
  </FormControl>
);

export default React.memo(MerchantNameField); 